<template>
  <main class="mx-4 lg:mx-40 py-14 md:py-28 lg:py-24">
    <div class="sm:block lg:flex lg:items-center">
      <div class="lg:w-2/5 lg:pr-4 space-y-4 text-base">
        <h2 class="text-primar-400 text-3xl leading-6 font-extrabold">
          {{ $t("contactView.getInTouch") }}
        </h2>
        <p class="text-primar-400 leading-7 font-normal lg:text-lg">
          {{ $t("contactView.haveQuestions") }}<br />
        </p>
        <address class="text-primar-500 leading-6 not-italic">
          <h4 class="text-primar-400 font-bold">{{ $t("contactView.byEmail") }}:</h4>
          <ul class="space-y-2 mt-2">
            <li class="flex items-start xl:items-center">
              <template v-if="$i18n.locale == 'br'">
                support-brazil@eronto.io
              </template>
              <template v-else>
                support@eronto.io
              </template>
            </li>
          </ul>
        </address>
        <address class="text-primar-500 leading-6 not-italic">
          <h4 class="text-primar-400 font-bold">{{ $t("contactView.byPhone") }}:</h4>
          <ul class="space-y-2 mt-2">
            <li>
              <img
                src="/images/icons8-great-britain-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="UK"
              /> +44 1133407985
            </li>
            <li>
              <img
                src="/images/icons8-mexico-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Mexico"
              /> +52 7443620256
            </li>
            <li>
              <img
                src="/images/icons8-ecuador-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Ecuador"
              /> +59 3963166842
            </li>
            <li>
              <img
                src="/images/icons8-peru-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Peru"
              /> +51 54755198
            </li>
            <li>
              <img
                src="/images/icons8-chile-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Chile"
              /> +56 228407941
            </li>
            <li>
              <img
                src="/images/icons8-colombia-96.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Colombia"
              /> +57 6019176152
            </li>
            <li>
              <img
                src="/images/br-flag-rounded.png"
                class="h-5 w-5 mr-2 inline-block"
                alt="Brazil"
              /> +55 2138282074
            </li>
          </ul>
        </address>
        <p class="text-primar-400 leading-7 font-normal">
          {{ $t("contactView.findAnswerWithUs") }}
        </p>
      </div>
      <div class="mt-10 lg:mt-0 lg:w-3/5">
        <form role="form" class="space-y-4" @submit="onSubmit">
          <div>
            <input
              type="text"
              class="
                w-full
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-white
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none focus:border-gray-300
              "
              :placeholder="$t('contactView.formFields.name')"
              required
              v-model="contact.name"
            />
          </div>
          <div>
            <input
              type="email"
              class="
                w-full
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-white
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none focus:border-gray-300
              "
              :placeholder="$t('contactView.formFields.email')"
              required
              v-model="contact.email"
            />
          </div>
          <div>
            <input
              type="tel"
              class="
                w-full
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-white
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none focus:border-gray-300
              "
              :placeholder="$t('contactView.formFields.phone')"
              required
              v-model="contact.phone"
            />
          </div>
          <div>
            <input
              type="text"
              class="
                w-full
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-white
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none focus:border-gray-300
              "
              :placeholder="$t('contactView.formFields.subject')"
              required
              v-model="contact.subject"
            />
          </div>
          <input type="hidden" v-model="contact.parser" />
          <div>
            <textarea
              class="
                w-full
                h-24
                lg:h-40
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-white
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none  focus:border-gray-300
              "
              :placeholder="$t('contactView.formFields.message')"
              required
              v-model="contact.message"
            />
          </div>
          <vue-turnstile @verified="token = $event" siteKey="0x4AAAAAAAgEg3kUChu_vXgI" />
          <button
            v-if="!isSending"
            type="submit"
            class="
              flex-shrink-0
              bg-primar-400
              hover:bg-opacity-90
              text-white
              font-medium
              text-sm
              xl:text-base
              py-2
              px-4
              rounded-md
              shadow
              focus:outline-none
              focus:ring-2
              focus:ring-blue-800
              focus:ring-offset-2
              focus:ring-offset-blue-200
            "
          >
            {{ $t('contactView.submit') }}
          </button>
          <button
            v-else
            class="
              flex-shrink-0
              bg-primar-400
              text-gray-500
              font-medium
              text-sm
              xl:text-base
              py-2
              px-4
              rounded-md
              shadow
            "
          >
            Sending...
          </button>
          <div
            v-if="sentSuccess"
            class="
              flex
              items-center
              bg-green-500
              text-white text-sm
              font-bold
              px-4
              py-3
            "
            role="alert"
          >
            <svg
              class="fill-current w-4 h-4 mr-2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"
              />
            </svg>
            <p>{{ $t('contactView.sendSuccess') }} </p>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
const axios = require("axios");

import VueTurnstile from '@gaviti/vue-turnstile';

export default {
  components: {VueTurnstile},
  created() {},
  data() {
    return {
      token: null,
      contact: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        parser: "",
      },
      sentSuccess: false,
      isSending: false,
    };
  },
  created() {
  },
  methods: {
    onloadTurnstileCallback() {
      window.onloadTurnstileCallback = () => {
        this.render();
      };
    },
    clearForm() {
      this.sentSuccess = false;
      for (let field in this.contact) {
        this.contact[field] = "";
      }
    },
    onSubmit(evt) {
      if (!this.token) {
        evt.preventDefault();
        return false;
      }
      evt.preventDefault();
      this.isSending = true;
      setTimeout(() => {
        let form = new FormData();
        for (let field in this.contact) {
          form.append(field, this.contact[field]);
        }
        form.append('token', this.token);
        axios
          .post("/api/public/contactForm", form)
          .then((response) => {
            this.clearForm();
            this.isSending = false;
            this.sentSuccess = true;
          })
          .catch((e) => {
            console.log(e);
          });
      }, 1000);
    },
  },
};
</script>
